export enum PNNVConstants {
  SET_NUMBERPAD_CALENDAR_IS_OPEN = 'pnnv/SET_NUMBERPAD_CALENDAR_IS_OPEN',
  SET_NUMBERPAD_CALENDAR_OPTIONS = 'pnnv/SET_NUMBERPAD_CALENDAR_OPTIONS',
  SET_NUMBERPAD_CALENDAR_CURRENT_PNNV_VALUE = 'pnnv/SET_NUMBERPAD_CALENDAR_CURRENT_PNNV_VALUE',
  SET_NUMBERPAD_CALENDAR_PNNV_CHANGE_HANDLER = 'pnnv/SET_NUMBERPAD_CALENDAR_PNNV_CHANGE_HANDLER',
  SET_NUMBERPAD_CALENDAR_PNNV_LABEL = 'pnnv/SET_NUMBERPAD_CALENDAR_PNNV_LABEL',
  SET_NUMBERPAD_CALENDAR_PNNV_LIST_HEADER = 'pnnv/SET_NUMBERPAD_CALENDAR_PNNV_LIST_HEADER',
  SET_NUMBERPAD_CALENDAR_CUSTOM_EVENT = 'pnnv/SET_NUMBERPAD_CALENDAR_CUSTOM_EVENT',
  SET_NUMBERPAD_CALENDAR_NEMSIS = 'pnnv/SET_NUMBERPAD_CALENDAR_NEMSIS',
  SET_FREE_TEXT_IS_OPEN = 'pnnv/SET_FREE_TEXT_IS_OPEN',
  SET_FREE_TEXT_SHOW_PWA_PNNV_BAR = 'pnnv/SET_FREE_TEXT_SHOW_PWA_PNNV_BAR',
  SET_FREE_TEXT_OPTIONS = 'pnnv/SET_FREE_TEXT_OPTIONS',
  SET_FREE_TEXT_CURRENT_PNNV_VALUE = 'pnnv/SET_FREE_TEXT_CURRENT_PNNV_VALUE',
  SET_FREE_TEXT_PNNV_CHANGE_HANDLER = 'pnnv/SET_FREE_TEXT_PNNV_CHANGE_HANDLER',
  SET_FREE_TEXT_PNNV_LABEL = 'pnnv/SET_FREE_TEXT_PNNV_LABEL',
  SET_FREE_TEXT_PNNV_LIST_HEADER = 'pnnv/SET_FREE_TEXT_PNNV_LIST_HEADER',
  SET_FREE_TEXT_CUSTOM_EVENT = 'pnnv/SET_FREE_TEXT_CUSTOM_EVENT',
  SET_FREE_TEXT_SHOW_CONFIRMATION = 'pnnv/SET_FREE_TEXT_SHOW_CONFIRMATION',
  SET_FREE_TEXT_NON_PNNV_DATA_RESET = 'pnnv/SET_FREE_TEXT_NON_PNNV_DATA_RESET',
  SET_FREE_TEXT_NEMSIS = 'pnnv/SET_FREE_TEXT_NEMSIS',
  SET_PNNV_STATE_VALUES = 'pnnv/SET_PNNV_STATE_VALUES',
  PREVENT_RESET_PNNV_VALUE = 'pnnv/PREVENT_RESET_PNNV_VALUE',
  SET_IS_OPEN_STATE = 'pnnv/SET_IS_OPEN_STATE',
  RESET_STATE = 'pnnv/RESET_STATE',
}
